/**
 * Maps an email template id to the variable group used by EmailBuilder.
 * booking  → template ids 1-6, 13-24
 * finance  → template ids 7, 8, 31, 32
 * station  → template ids 9-12
 * everything else falls back to "finance"
 */
export function groupForTemplate(id: number | null): string {
	if (id === null) return "finance";
	if ((id >= 1 && id <= 6) || (id >= 13 && id <= 24)) return "booking";
	if (id === 7 || id === 8 || id === 31 || id === 32) return "finance";
	if (id >= 9 && id <= 12) return "station";
	return "finance";
}

/**
 * Returns the list of required template variables for a given group.
 * These vars must be present somewhere in the serialized content before saving.
 */
const REQUIRED_VARS_BY_GROUP: Record<string, string[]> = {
	booking: ["${orderId}"],
	finance: ["${totalAmount}", "${currencyCode}"],
	station: ["${email}"],
};

export function getRequiredVars(group: string): string[] {
	return REQUIRED_VARS_BY_GROUP[group] ?? [];
}
